var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"all-course"},[_c('div',{staticClass:"filter-box"},_vm._l((_vm.list),function(menu){return _c('div',{key:menu,class:['menu-item', { active: _vm.active === menu }]},[_vm._v("\n      "+_vm._s(menu)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }